import styled from '../../../../../../styles/styledComponents/themeComponents';

export const UrlInputStyle = styled.div`
  margin-top: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
  }

  .product-category-search {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
  .product-category-search-btn {
    margin-left: 5px;
    font-size: 34px;
  }
`;
